import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from './utils.service';
import { Observable, switchMap } from 'rxjs';
import { RegisteredSerial } from '../models/registered-serial';
import { environment } from '../../environments/environment';
import { Page } from '../models/page';
import { RegisterSerialRequest } from '../models/register-serial-request';
import { URL } from '../models/url';
import { FileUploadRequest } from '../models/file-upload-request';
import { CouponResponse } from '../models/coupon-response';
import { CouponRequest } from '../models/coupon-request';

@Injectable()
export class RegisteredSerialsService {

  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  getRegisteredSerials(): Observable<Page<RegisteredSerial>> {
    return this.http.get<Page<RegisteredSerial>>(
      environment.apiName + '/registered-serials',
      {
        headers: this.utils.getRequestHeaders()
      }
    );
  }

  getRegisteredSerial(id: number): Observable<RegisteredSerial> {
    return this.http.get<RegisteredSerial>(
      environment.apiName + `/registered-serials/${id}`,
      {
        headers: this.utils.getRequestHeaders()
      }
    );
  }

  checkRegisteredSerial(serial: string): Observable<RegisteredSerial> {
    return this.http.get<RegisteredSerial>(
      environment.apiName + `/registered-serials/check`,
      {
        params: {
          serialCode: serial
        }
      }
    );
  }

  registerSerial(data: RegisterSerialRequest): Observable<RegisteredSerial> {
    return this.http.post<RegisteredSerial>(
      environment.apiName + '/registered-serials',
      data,
      {
        headers: this.utils.getRequestHeaders()
      }
    );
  }

  private uploadFile(id: number, data: FileUploadRequest): Observable<URL> {
    return this.http.post<URL>(
      environment.apiName + `/registered-serials/${id}/file`,
      data,
      {
        headers: this.utils.getRequestHeaders()
      }
    );
  }

  private uploadFileToURL(file: File, url: string): Observable<void> {
    return this.http.put<void>(
      url,
      file
    );
  }

  uploadSerialFile(id: number, file: File, date: string, lang: string): Observable<void> {
    const data: FileUploadRequest = {
      fileName: file.name,
      mimeType: file.type,
      purchaseDate: date,
      lang: lang
    }
    return this.uploadFile(id, data).pipe(
      switchMap(url => {
        return this.uploadFileToURL(file, url.url);
      })
    );
  }

  postCoupon(data: CouponRequest): Observable<CouponResponse> {
    return this.http.post<CouponResponse>(
      environment.apiName + '/registered-serials/coupon',
      data,
      {
        headers: this.utils.getRequestHeaders()
      }
    );
  }
}
